export abstract class ImageMetadata {}
